import AaveIcon from './AaveIcon'

export default AaveIcon
